import React from "react";
import * as styles from "./FooterCDCDisclaimer.module.scss";
import { useGeolocation } from "../../../../utils/localization/geolocation/GeolocationContext";

const FooterCDCDisclaimer: React.FC<React.PropsWithChildren> = () => {
  const location = useGeolocation();
  return (
    <React.Fragment>
      {location.countryCode === "GB" && (
        <div className={styles.cdcDisclaimerContainer}>
          <p>
            <img
              className={styles.abtaLogo}
              src="https://cdn.sanity.io/images/rd0y3pad/production/0055914ebed962005053210a2ab416903092e73a-220x80.png"
              alt="ABTA"
              loading="lazy"
              width="177"
              height="64"
            />
            All the flights and flight-inclusive holidays on this website are
            financially protected by the ATOL scheme. When you pay you will be
            supplied with an ATOL Certificate. Please ask for it and check to
            ensure that everything you booked (flights, hotels and other
            services) is listed on it. Please see our booking conditions for
            further information or for more information about financial
            protection and the ATOL Certificate go to:{" "}
            <a href="https://www.caa.co.uk/">www.caa.co.uk</a>. Our ATOL number
            is 4681 and our ABTA number is Y262X.
          </p>
        </div>
      )}
    </React.Fragment>
  );
};

export default FooterCDCDisclaimer;
